import { useState, useEffect } from 'react'
import { DateTime } from "luxon"

const GOOGLE_SHEETS_KEY = "AIzaSyB0_o137FV0JbNaHObRAhBAfkfbdtwbHvA"
const API_URL =
  'https://sheets.googleapis.com/v4/spreadsheets/10p1rtbNWjxsxcoq8kMHVBkw9MwSh3IY-kQJ0IgNBsLI/values/Sheet1?key=AIzaSyB0_o137FV0JbNaHObRAhBAfkfbdtwbHvA'

let cachedData = null
let pendingPromise = null

export function useMallbrawlShows() {
  const [shows, setShows] = useState(cachedData || [])
  const [loading, setLoading] = useState(!cachedData)

  useEffect(() => {
    if (cachedData) {
      setLoading(false)
      return
    }

    if (!pendingPromise) {
      pendingPromise = async function load() {
        try {
          const res = await fetch(API_URL)
          const data = await res.json()

          // validate some stuff about the sheet
          const rows = data.values
          if (!rows || rows.length < 2) {
            return []
          }

          // get headers and ROWS
          const headers = rows[1] // these are dictated by the literal name in the google sheet
          const dataRows = rows.slice(2) // --- actual data rows ---

          // parse a row into a show object eg. { locationName: "High Limit Room", etc}
          const mallbrawlShows = dataRows
            .filter(r => r.length > 1)
            .map(row => {
              const show = {}
              headers.forEach((headerColumnName, i) => {
                show[headerColumnName] = row[i] || ''

                //process columns
                if (headerColumnName == "address" && /\d/.test(show.address)) {
                  // add google map link to real addresses (has numbers)
                  show.addressLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(show.address)}`
                }
                if (headerColumnName == "startTime") {
                  // calc timestamp
                  show.ts = parseEndTimePST(show.date, show.startTime)
                }
                if (headerColumnName == "title") {
                  // title newline
                  show.title = show.title.replace(/\\n/g, "\n");
                }
                if (headerColumnName == "ticketLink" && !show.ticketLink.includes("https")) {
                  // handle misc text for tickets
                  show.ticketText = show.ticketLink
                  show.ticketLink = null
                }
              })
              return show
            })

          console.log(mallbrawlShows)
          return mallbrawlShows

        } catch (err) {
          console.error(err)
          return []
        }
      }()
    }

    pendingPromise.then(result => {
      cachedData = result
      setShows(result)
      setLoading(false)
    })

  }, [])

  return { shows, loading }
}

function parseEndTimePST(dateStr, timeStr) {
  const cleanDate = dateStr.replace(/^[A-Za-z]+,\s*/, "").trim()

  return DateTime.fromFormat(
    `${cleanDate} ${timeStr}`,
    "MMMM d, yyyy h:mm:ss a",
    { zone: "America/Los_Angeles" }
  )
  .plus({ days: 1 })
  .startOf("day")
  .toMillis()
}
